import {
  Box, Typography,
} from '@mui/material';
import styled from '@emotion/styled';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { navMenuItems } from '../../constants/MenuConstants';
import { UserDetails } from '../../store/user/user-slice';
import { RootState } from '../../store';

const MobileOnlyAnchor = styled('a')({
  display: 'none',
  '@media (max-width: 767px)': {
    display: 'inline',
  },
});

export default function PrimaryMenu() {
  const user:UserDetails = useSelector((state: RootState) => state.user);

  return (
    <Box
      gap={4}
      sx={{
        display: { xs: 'none', md: 'flex' },
        alignItems: 'center',
        flex: 1,
        justifyContent: 'center',
      }}
    >
      {navMenuItems.filter((item) => (
        item.visibility === 'all'
        || (user.isLoggedIn && item.visibility === 'loggedin')
        || (!user.isLoggedIn && item.visibility === 'loggedout')
        || (user.isAdmin && item.visibility === 'admin')
      ))
        .map((item) => (
          <Typography key={item.key} variant="body1">
            {item.navLink.startsWith('https://')
              ? (
                <MobileOnlyAnchor href={item.navLink} target="_blank" style={{ color: '#FFF', textDecoration: 'none' }} rel="noreferrer">{item.value}</MobileOnlyAnchor>
              )
              : (
                <Link to={item.navLink} style={{ textDecoration: 'none', color: 'inherit' }}>{item.value}</Link>
              )}
          </Typography>
        ))}
    </Box>
  );
}
